<template>
  <DomainCrawlScheduleForm :crawl-schedule="crawl_schedule" @submit="onSubmit($event)" v-if="!isLoading"></DomainCrawlScheduleForm>
</template>

<script>

  import DomainCrawlScheduleForm from './DomainCrawlScheduleForm';
  import DomainService from "../services/Domain.service";

  export default {
    name: 'DomainCrawlScheduleEdit',
    components: {
      DomainCrawlScheduleForm
    },
    data() {
      return {
        isLoading: true,
        crawlScheduleId: this.$route.params.id,
        crawl_schedule: {
          domain_id: null,
          name: null,
          crawl_depth: 5,
          interval: null,
          user_agent_id: null,
          text_string_appear: null,
          text_string_not_appear: null,
          policy_id: null
        }
      };
    },
    mounted() {
      this.getDomainCrawlSchedule();
    },
    methods: {
      onSubmit(event) {
        DomainService.updateDomainCrawlSchedule(this.$route.params.id, event).then(() => {
          this.$router.push('/domain/list-crawl-schedule');
          this.$showSuccessMessage('Updated Crawl Schedule');
        });
      },
      async getDomainCrawlSchedule() {
        try {
          this.crawl_schedule = await DomainService.getDomainCrawlSchedule(this.crawlScheduleId);
          this.isLoading = false;
        } catch (error) {
          this.$showErrorMessage('Failed to load crawl schedule');
          this.$router.push('/domain/list-crawl-schedule');
        }
      },
    }
  };
</script>

<style lang="scss" scoped></style>
